import momentHelper from 'scoreboard/components/moment-helper'
import dateValidatorFactory from './date-validator-factory'

export default dateValidatorFactory(momentHelper.numericDateFormat)
